import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ErrorMessage } from '../../../../shared/models/error-message/error-message';
import { ErrorMessageApiService } from '../../../services/api/error-message-api.service';
import { Stepper } from '../../common/stepper/stepper';
import { ChangesInOtherVersionsTable } from '../../tables/changes-in-other-versions-table/changes-in-other-versions-table';
import { PropagateChangesToEntitiesInOtherVersionsModalBase } from './propagate-changes-to-entities-in-other-versions-modal';
import { AgentActionDirective } from '../../../directives/agent-action.directive';

@Component({
  selector: 'app-propagate-error-message-changes-to-entities-in-other-versions-modal',
  imports: [ChangesInOtherVersionsTable, Stepper, AgentActionDirective],
  templateUrl: './propagate-changes-to-entities-in-other-versions-modal.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './propagate-changes-to-entities-in-other-versions-modal.scss',
})
export class PropagateErrorMessageChangesToEntitiesInOtherVersionsModal extends PropagateChangesToEntitiesInOtherVersionsModalBase<ErrorMessage> {
  protected readonly propertyUpdateInfoApi = inject(ErrorMessageApiService);

  protected override get agentBusinessObject(): string {
    return 'errorMessage';
  }
}
